/* eslint-disable no-await-in-loop */
import { getRequest } from 'api'
import delay from 'utils/delay'

const pollRequest = async (deviceId: string, requestId: number) => {
  let poll
  let requestStatus = 'pending'
  while (requestStatus === 'pending') {
    poll = await getRequest(deviceId, requestId)
    requestStatus = poll.request.status
    if (requestStatus === 'success') break
    await delay()
  }
  return poll
}

export default pollRequest
